import { Action, ActionReducer } from '@ngrx/store';
import { CreateProfileState } from './create-profile-state';
import { CreateProfileUIActions } from './actions/create-profile-ui-actions';
import {
    CreateProfileServiceActions,
    AccountCreatedAction,
    AccountCreationFailedAction,
} from './actions/create-profile-service-actions';

export const createProfileInitialState: CreateProfileState = {
    isWaitingForAPIResponse: false,
    result: null,
};

export const createProfileReducer: ActionReducer<CreateProfileState, Action> = (
    state: CreateProfileState = createProfileInitialState,
    action: Action,
): CreateProfileState => {
    switch (action.type) {
        case CreateProfileUIActions.CreateUserAccountBtnClicked: {
            const newState: CreateProfileState = {
                isWaitingForAPIResponse: true,
                result: null,
            };
            return newState;
        }
        case CreateProfileServiceActions.AccountCreated: {
            const result: AccountCreatedAction = action as AccountCreatedAction;
            const newState: CreateProfileState = {
                isWaitingForAPIResponse: false,
                result: result.props,
            };
            return newState;
        }
        case CreateProfileServiceActions.AccountCreationFailed: {
            const result: AccountCreationFailedAction =
                action as AccountCreationFailedAction;
            const newState: CreateProfileState = {
                isWaitingForAPIResponse: false,
                result: result.props,
            };
            return newState;
        }
        default: {
            return state;
        }
    }
};
